module.exports = __webpack_public_path__ + "img/vertical_4_2_3009.13f1e9c2.png";